import React from "react";
import { Button } from "./Button";
import "./BannerSection.css";
import videoSource from "../assets/video.mp4";

function BannerSection() {
  return (
    <>
      {/* <video autoPlay loop muted className="video-bg">
        <source src={videoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <div className="ratio ratio-21x9">
        <video
          src={videoSource}
          title="video"
          allowFullScreen
          autoPlay
          muted
          loop
        ></video>
        <div className="banner-content">
          <h1>Maitri Diamonds</h1>
          <p>
            Discover the world's first fully traceable, 100% Climate Neutral and
            Sustainability Rated diamonds — grown in our Indian laboratory using
            our patenteadscadcd CVD technology.
          </p>

          <div className="hero-btn row">
            <div className="col-sm-6 mb-3">
              <Button
                className="button"
                buttonStyle="btn__rounded"
                buttonSize="btn__large"
              >
                Diamonds
              </Button>
            </div>
            <div className="col-sm-6">
              <Button
                className="button"
                buttonStyle="btn__rounded"
                buttonSize="btn__large"
              >
                Jewelry
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BannerSection;
